export default __webpack_public_path__ + "static/media/background-05.1f42fa53.png";